/**
 * Custom sessionStorage adapter for redux-persist
 * This ensures Redux state is NOT shared between browser tabs
 * Each tab has its own isolated sessionStorage
 */

const sessionStorageAdapter = {
  getItem: (key: string) => {
    try {
      const item = window.sessionStorage.getItem(key)
      return item ? Promise.resolve(item) : Promise.resolve(null)
    } catch (error) {
      console.warn('Error reading from sessionStorage:', error)
      return Promise.resolve(null)
    }
  },

  setItem: (key: string, value: string) => {
    try {
      window.sessionStorage.setItem(key, value)
      return Promise.resolve()
    } catch (error) {
      console.warn('Error writing to sessionStorage:', error)
      return Promise.resolve()
    }
  },

  removeItem: (key: string) => {
    try {
      window.sessionStorage.removeItem(key)
      return Promise.resolve()
    } catch (error) {
      console.warn('Error removing from sessionStorage:', error)
      return Promise.resolve()
    }
  }
}

export default sessionStorageAdapter
